var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6226 4.80364C11.0767 4.80364 11.4951 5.0499 11.7155 5.44693L13.2445 8.20119C13.4447 8.56181 13.4542 8.998 13.2697 9.36694L11.7967 12.313C11.7967 12.313 12.2235 14.5076 14.01 16.2941C15.7965 18.0806 17.9839 18.5001 17.9839 18.5001L20.9294 17.0274C21.2986 16.8427 21.7351 16.8523 22.0959 17.0529L24.8579 18.5885C25.2545 18.8091 25.5005 19.2272 25.5005 19.681V22.8519C25.5005 24.4667 24.0006 25.6331 22.4705 25.1167C19.3281 24.0564 14.4502 22.0376 11.3584 18.9457C8.26661 15.854 6.24774 10.9761 5.18741 7.83362C4.67114 6.30356 5.83745 4.80364 7.45224 4.80364H10.6226Z",
    stroke: "currentColor",
    strokeWidth: 1.625,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon-phone.51068fc55ba357ab26e5b62725981b4c.svg";
export { ForwardRef as ReactComponent };